// extracted by mini-css-extract-plugin
export var aiStarIcon = "_be-4";
export var closeButton = "_be-6";
export var dismissButton = "_be-3";
export var editImageWithAiContainer = "_be-8";
export var imageUploadWrapper = "_be-7";
export var misspelledWord = "_be-5";
export var spellCheckContainer = "_be-2";
export var spin = "_be-1";
export var spinning = "_be-0";